// let url = 'http://pasukserverstaging.dicta.org.il/PasukFinder/api/markpsukim';
// import {URLS} from "../common/Globals";
// let url = '/api';
import $ from 'jquery';

export function ApiCall (url, type, data, cb,  isLoaderShow = true) {
    if(isLoaderShow){
        $('#loader').show();
    }
    $.ajax({
        url: url,
        type: type,
        data: data,
        cache: false,

        // ON ERROR
        error: function (jqXHR, textStatus, errorThrown) {
            // WILL FIRE WHEN TIME OUT REACH
            if (jqXHR.status === 500) {

                alert("500 Internal Server Error. Oh no! Something bad happened. Please try again. If it still doesn't work come back later when we fixed the problem. Thanks.");
            }
            else {
                alert("Server Timeout. Looks like we are having some difficulties in processing your request. Please try again. If it still doesn't work come back later when we fixed the problem. Thanks.");
            }

            $('#loader').hide();

        },
        // ON SUCCESS
        success: function (data) {
            if (data !== '{}') {
                $('#loader').hide();
                cb(JSON.parse(data));
            }else {
                $('#loader').hide();
                alert("No response against your search.");

            }

        },
        timeout: 10000
    });
}



// WEBPACK FOOTER //
// ./src/actions/HttpCall.js